import Link from 'next/link';
import React from 'react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './breadcrumb';

export interface IBreadCrumb {
  href?: string;
  label: string;
}

interface BreadcrumbProps {
  crumbs: IBreadCrumb[];
  containerClassName?: string;
}

const Breadcrumbs: React.FC<BreadcrumbProps> = ({ crumbs, containerClassName = '' }) => {
  return (
    <Breadcrumb className={`mb-6 ${containerClassName}`}>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <React.Fragment key={index}>
              <BreadcrumbItem>
                {!isLast && crumb.href ? (
                  <BreadcrumbLink asChild>
                    <Link href={crumb.href} className="text-therablue">
                      {crumb.label}
                    </Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage className="text-neutral-800">{crumb.label}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default Breadcrumbs;
